import { LassoItemComponent } from './LassoItem.component';
import { enhance } from './LassoItem.enhancers';

export const LassoItem = enhance(LassoItemComponent);
